<template>

  <div>
    <div class="list-group list-group-flush mt-3">

      <!--:to="{name: 'material', params: {id: material.id}}"-->
      <router-link-locale
          v-for="(material, index) in materials"
          :key="material.id"
          :to="getRoute(material)"
          class="list-group-item list-group-item-action flex-column align-items-start p-2"
          tag="li"
      >

        <ItemListMaterial v-if="(material.tipus === 'material' || (material.tipus === 'activitat' && (material.activitat_comunitat && material.activitat_comunitat[0] === 'pfc')))" :material="material" :index="index" />

        <ItemListDocenciaImpartida v-else-if="material.activitat_subtipus === 'docencia' && material.activitat_subtipus_docencia === 'assignaturesImpartidas'" :material="material" :index="index" />

        <ItemListDocencia v-else-if="material.activitat_subtipus === 'docencia' && material.activitat_subtipus_docencia === 'estadaCentreRDI'" :material="material" :index="index" />

        <ItemListInnovacio v-else-if="material.activitat_subtipus === 'innovacio'" :material="material" :index="index" />

        <ItemListPremi v-else-if="material.activitat_subtipus === 'premis'" :material="material" :index="index" />

        <ItemListFormacio v-else-if="material.activitat_subtipus === 'formacio'" :material="material" :index="index" />

        <ItemListTutoria v-else-if="material.activitat_subtipus === 'tutoria'" :material="material" :index="index" />


      </router-link-locale>

    </div>
  </div>

</template>

<script>


import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import {imageUrlAlt} from "@/utils/utils";
import ItemListMaterial from "@/components/itemList/ItemListMaterial.vue";
import ItemListDocencia from "@/components/itemList/ItemListDocencia.vue";
import ItemListInnovacio from "@/components/itemList/ItemListInnovacio.vue";
import ItemListPremi from "@/components/itemList/ItemListPremi.vue";
import ItemListFormacio from "@/components/itemList/ItemListFormacio.vue";
import ItemListTutoria from "@/components/itemList/ItemListTutoria.vue";
import ItemListDocenciaImpartida from "@/components/itemList/ItemListDocenciaImpartida.vue";

export default {

  name: "ListActivitats",
  methods: {imageUrlAlt},
  components: {
    ItemListDocenciaImpartida,
    ItemListTutoria,
    ItemListFormacio,
    ItemListPremi,
    ItemListInnovacio, ItemListDocencia, ItemListMaterial, RouterLinkLocale},
    props: {
      materials: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    setup() {

      const getRoute = (material) => {
        return material.activitat_subtipus === 'docencia' &&  material.activitat_subtipus_docencia === 'assignaturesImpartidas'
            ? { name: 'assignatura', params: { id: material.activitat_assignatures[0], sort: 'data desc' } }
            : { name: 'material', params: { id: material.id, sort: 'data desc' } };
      };

      const hideShow = (index) => {
        const element = document.getElementById(index);
        if (element) {
          if (element.style.display === 'none') {
            element.style.display = 'block';
          } else {
            element.style.display = 'none';
          }
        }
      };

      return {
        hideShow,
        getRoute
      }
    }
}
</script>

<style scoped>
button:hover {
  text-decoration: underline;
}
</style>

